export default __webpack_public_path__ + "static/media/Adveni.65642330.jpg";